import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../components/Navbar";
import WaitlistDashboard from "../../components/Waitlist";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const Waitlist = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.waitlist?.hasAccess) {
      navigate(LOGIN);
    }
  }, [userConfig?.waitlist?.hasAccess, navigate]);

  return (
    <>
      <Navbar />
      <WaitlistDashboard ROOT_URL={ROOT_URL} />
    </>
  );
};

export default Waitlist;
